import { Component, OnInit } from '@angular/core';
import { Campus } from 'src/app/core/models/api/campus.model';
import { CampusService } from 'src/app/core/services/api/campus.service';

@Component({
    selector: 'app-sponsors-toolbar',
    templateUrl: './sponsors-toolbar.component.html',
    styleUrls: ['./sponsors-toolbar.component.scss']
})
export class SponsorsToolbarComponent implements OnInit {

    public campus : Campus;
    public sponsorsList: string[] = [];
    
    constructor(private campusService: CampusService) { }

    ngOnInit() { 

        this.campus = this.campusService.campusActive;
        this.getSponsorsResources();

    }

    getSponsorsResources() {

        var sponsorsResources = this.campus.resources.filter(cr => cr.resourceId.startsWith('sponsor-'));
        sponsorsResources.forEach(sponsor => {
            this.sponsorsList.push(sponsor.value);
        });

    }

}
